import {CREATE_LOG_UNDO, GET_CREATE_LOG_UNDO, LogCreate } from "../../../Model/Log"

const initState: LogCreate = {
    ResultDtoCreate: null,
    LogCreate: null,
}
//const dispatch = useDispatch();


export const LogUndoCreateReducer = (state = initState, action: { type: string, payload: LogCreate }) => {
    switch (action.type) {
        case CREATE_LOG_UNDO:
            {
                return { ...state, ResultDtoCreate: action.payload.ResultDtoCreate }
            }
        case GET_CREATE_LOG_UNDO:
            return { ...state, LogDtoCreate: action.payload.LogCreate }
        default:
            return state;
    }
}